// extracted by mini-css-extract-plugin
module.exports = {"form-inner":"Mailchimp_form-inner__31Z0U","mc-field-group":"Mailchimp_mc-field-group__2CPyc","input":"Mailchimp_input__2WVIH","checkbox":"Mailchimp_checkbox__36whb"};